import toastr from 'toastr';
import { i18n } from '@/plugins/i18n';


export function getFullscreenElement() {
  return document.fullscreenElement
    || document.webkitFullscreenElement
    || document.mozFullScreenElement
    || document.msFullscreenElement;
}

export function isFullscreenEnabled() {
  return document.fullscreenEnabled
    || document.webkitFullscreenEnabled
    || document.mozFullScreenEnabled
    || document.msFullscreenEnabled;
}

// TODO addToHomescreen on Safari mobile
export function requestFullscreen(elmt) {
  elmt = elmt || document.body;
  if (elmt.requestFullscreen) {
    return elmt.requestFullscreen();
  }
  if (elmt.webkitRequestFullscreen) {
    return elmt.webkitRequestFullscreen();
  }
  if (elmt.mozRequestFullScreen) {
    return elmt.mozRequestFullScreen();
  }
  if (elmt.msRequestFullscreen) {
    return elmt.msRequestFullscreen();
  }
  toastr.error(i18n.t('message.FS_NOT_SUPPORTED'));
  return Promise.reject(new Error('Fullscreen not supported'));
}

export function exitFullscreen() {
  if (document.exitFullscreen) {
    return document.exitFullscreen();
  }
  if (document.webkitExitFullscreen) {
    return document.webkitExitFullscreen();
  }
  if (document.mozCancelFullScreen) {
    return document.mozCancelFullScreen();
  }
  if (document.msExitFullscreen) {
    return document.msExitFullscreen();
  }
  toastr.error(i18n.t('message.FS_NOT_SUPPORTED'));
  return Promise.reject(new Error('Fullscreen not supported'));
}

export function toggleFullscreen(elmt) {
  if (!(elmt instanceof Element)) {
    elmt = document.body;
  }
  const fullscreenElement = getFullscreenElement();
  if (fullscreenElement === elmt) {
    return exitFullscreen();
  }
  return requestFullscreen(elmt);
}

export default {
  getFullscreenElement,
  isFullscreenEnabled,
  requestFullscreen,
  exitFullscreen,
  toggleFullscreen,
};
